import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=1fe92cce&scoped=true&"
import script from "./AppFoot.vue?vue&type=script&lang=ts&"
export * from "./AppFoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe92cce",
  null
  
)

export default component.exports